// components/QuickStats.jsx

import React from "react";
import { Grid,Button, Paper,Typography,Box} from "@mui/material";

import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";

import StatCard from "./StatCard";

const QuickStats = ({ stats }) => {
  const cards = [
    {
      title: "Orders",
      value: stats?.orders || 0,
      icon: <ShoppingBagOutlinedIcon />,
      color: "#1976d2",
      route: "/all-orders",
    },
    {
      title: "Reports",
      value: stats?.reports || 0,
      icon: <DescriptionOutlinedIcon />,
      color: "#7b1fa2",
      route: "/diagnostic-reports",
    },
    {
      title: "Prescriptions",
      value: stats?.prescriptions || 0,
      icon: <MedicalServicesOutlinedIcon />,
      color: "#2e7d32",
      route: "/prescriptions",
    },
  ];

  return (
    <Grid container spacing={2}>
      {cards.map((card) => (
        <Grid
          item
          xs={6}
          md={3}
          key={card.title}
        >
          <StatCard {...card} />
        </Grid>
      ))}
      <Paper
      elevation={0}
      sx={{
        flex: 1,
        p: 3,
        borderRadius: 4,
        color: "#fff",
        background:
          "linear-gradient(135deg,#006D77,#0097A7)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box>
        <Typography variant="subtitle2" sx={{ opacity: 0.9 }}>
          AYUJA REWARDS
        </Typography>

        <Typography variant="h2" fontWeight={700} mt={1}>
          {stats.rewardPoints}
        </Typography>

        <Typography variant="body2">
          Reward Points Available
        </Typography>

        <Button
          variant="contained"
          sx={{
            mt: 2,
            bgcolor: "#fff",
            color: "#006D77",
            "&:hover": { bgcolor: "#f5f5f5" },
          }}
        >
          Redeem Now
        </Button>
      </Box>

      <WorkspacePremiumOutlinedIcon
        sx={{
          fontSize: 80,
          opacity: 0.2,
        }}
      />
    </Paper>
    </Grid>
  );
};

export default QuickStats;